<template>
  <div class="step-list">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "StepList",
  props: {
    type: { type: String, default: "" },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
</style>
